var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveWhiteBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2_00000120531529945100664490000007520320253768401317_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 445 50.5",
    style: {
      enableBackground: "new 0 0 445 50.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296,41c77,0,127.1-20.9,149-35.8V0H0v50.5C33,41,52,2,102,2C187,2,202,41,296,41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveWhiteBottom);
export default __webpack_public_path__ + "static/media/wave-white-bottom.6d78c76b86862bae2af6aa2d50e8f675.svg";
export { ForwardRef as ReactComponent };